import Router from "@/router";
import CommonFunction from "@/utils/CommonFunction";

export const EDITOR_CONTENT_THEME = Object.freeze([
    {name: "美术设计", value: 'ant-design'},
    {name: "黑暗模式", value: "dark"},
    {name: "浅色模式", value: "light"},
    {name: "微信文章", value: "wechat"},
])

export const PUBLISH_TYPE = Object.freeze({
    article: {cnName: '文章', enName: 'ARTICLE', type: 'BLOG', name: 'title'},
    info: {cnName: '信息', enName: 'INFO', type: 'INFO', name: 'title'}
})

export const FEED_BACK_TYPE = Object.freeze({
    BLOG: "BLOG",
    INFO: "INFO",
    CUSTOM_INFO: "CUSTOM_INFO",
    USER: "USER",
    AD: "AD",
    OTHER: "OTHER",
    COMMENT: "COMMENT"
})


export const INFO_TYPE = Object.freeze(["餐厅", "景区", "酒店", "其他旅行辅助人", "景区二销"])


export const DUPLICATION_TYPE = Object.freeze({
    USERNAME: "username",
    PHONE: "phone",
    MAIL: "mail",
})
export const FILTER_TYPE = Object.freeze({
    TO_UPPER_CASE: 'to-upper-case',
    TO_LOWER_CASE: 'to-lower-case',
    TRIM: 'trim',
    ONLY_NUMBER: 'only-number',
    ONLY_LETTER: 'only-letter',
    ONLY_CHINESE: 'only-chinese',
    JUST_NUMBER_AND_LETTER: 'just-number-and-letter',
    NUMBER_AND_FLOAT: 'number-and-float',
    NO_SPACE: 'no-space',
    NO_CHINESE: 'no-chinese',
    // 带参数的过滤器实现
    // 带参数的过滤器实现（函数形式）
    LENGTH: function (length) {
        return function (val) {
            return val.substring(0, length);
        };
    },
    PHONE: 'phone',
    TEL: 'tel',
    ALL_PHONE:'all-phone',
    ID_CARD: 'id-card',
    /*NOT_REGEXPS: NOT_REGEXPS,*/
})
export const SHARE_TYPE = Object.freeze({
    isImplement: [
        {
            name: '复制链接', icon: 'link', func: () => {
                console.log(Router.currentRoute, location.href)
                CommonFunction.copyText(location.href, '链接');
            }
        },
        {name: '分享海报', icon: 'poster'},
        {name: '二维码', icon: 'qrcode'},
    ],
    unImplement: [
        {name: '微信', icon: 'wechat', description: '尚未实现'},
        {name: '朋友圈', icon: 'wechat-moments', description: '尚未实现'},
        {name: '微博', icon: 'weibo', description: '尚未实现'},
        {name: 'QQ', icon: 'qq', description: '尚未实现'},
    ]
})

export const EventBusKey = Object.freeze({
    previewImages: "PREVIEW_IMAGES",
    previewVideos: "PREVIEW_VIDEOS",
    circleProgress: "CIRCLE_PROGRESS",
    resize: "RESIZE",
    scroll: "SCROLL",
    toolBarHide: "TOOLBAR_HIDE",
    menuVisible: "MENU_VISIBLE",
    publish: 'PUBLISH',
    viewId: 'VIEW_ID',
    refreshObservers: 'REFRESH_OBSERVERS',
    generateImage: 'GENERATE_IMAGE',


})

export const VISIBLE_RANGE = Object.freeze(["全部可见", "仅导游", "仅旅行社", "导游和旅行社", "导游和企业"])
export const UPLOAD_DIR = Object.freeze({
    articleCoverImage: "article-cover-image",
    articleFile: "article-content-file",
    userAvatar: "user-avatar",
    infoImage: "info-image",
})
export const LOCAL_STORAGE_KEY = Object.freeze({
    currentUser: "CURRENT_GB_USER",
    isAuthenticated: "IS_AUTHENTICATED",
    token: "GB_TOKEN",
    config: "GB_CONFIG",
    bg: "GB_BACKGROUND_IMAGE",
    payImage: "payQrImage",
    concatQrImage: "concatQrImage",
    ORDER: "order.data.",
    addInfo: function (userId) {
        return "ADD_INFO_" + userId
    },
    addArticle: function (userId) {
        return "ADD_ARTICLE_" + userId;
    }
})

export const SIZE = Object.freeze({
    MB1: 1024 * 1024,
    MB2: 2 * 1024 * 1024,
    MB3: 3 * 1024 * 1024,
    KB1: 1024,
    GB1: 1024 * 1024 * 1024,
    GB2: 2 * 1024 * 1024 * 1024,
    GB: function (p = 1) {
        return p * 1024 * this.MB;
    },
    MB: function (p = 1) {
        return p * 1024 * 1024;
    }


})
export const LOGIN_TYPE = Object.freeze({password: "PASSWORD", verifyCode: "VERIFY_CODE", wechat: "WECHAT"})

export const CONTENT_THEME = Object.freeze([
    {name: '黑暗', value: 'dark'},
    {name: '经典', value: 'classic'}
])

export const AREA_CODE = Object.freeze({
    NAME_LIST: [{code: "010", city: "北京市"}, {code: "022", city: "天津市"}, {
        code: "021",
        city: "上海市"
    }, {code: "023", city: "重庆市"}, {code: "0310", city: "邯郸市"}, {code: "0311", city: "石家庄市"}, {
        code: "0312",
        city: "保定市"
    }, {code: "0313", city: "张家口市"}, {code: "0314", city: "承德市"}, {code: "0315", city: "唐山市"}, {
        code: "0316",
        city: "廊坊市"
    }, {code: "0317", city: "沧州市"}, {code: "0318", city: "衡水市"}, {code: "0319", city: "邢台市"}, {
        code: "0335",
        city: "秦皇岛市"
    }, {code: "0349", city: "朔州市"}, {code: "0350", city: "忻州市"}, {code: "0351", city: "太原市"}, {
        code: "0352",
        city: "大同市"
    }, {code: "0353", city: "阳泉市"}, {code: "0354", city: "晋中市"}, {code: "0355", city: "长治市"}, {
        code: "0356",
        city: "晋城市"
    }, {code: "0357", city: "临汾市"}, {code: "0358", city: "吕梁市"}, {code: "0359", city: "运城市"}, {
        code: "0470",
        city: "呼伦贝尔市"
    }, {code: "0471", city: "呼和浩特市"}, {code: "0472", city: "包头市"}, {
        code: "0473",
        city: "乌海市"
    }, {code: "0475", city: "通辽市"}, {code: "0476", city: "赤峰市"}, {
        code: "0477",
        city: "鄂尔多斯市"
    }, {code: "0478", city: "巴彦淖尔市"}, {code: "0479", city: "锡林郭勒盟"}, {
        code: "0482",
        city: "乌兰察布市"
    }, {code: "0482", city: "兴安盟"}, {code: "0483", city: "阿拉善盟"}, {code: "024", city: "沈阳市"}, {
        code: "0410",
        city: "铁岭市"
    }, {code: "0411", city: "大连市"}, {code: "0412", city: "鞍山市"}, {code: "0413", city: "抚顺市"}, {
        code: "0414",
        city: "本溪市"
    }, {code: "0415", city: "丹东市"}, {code: "0416", city: "锦州市"}, {code: "0417", city: "营口市"}, {
        code: "0418",
        city: "阜新市"
    }, {code: "0419", city: "辽阳市"}, {code: "0421", city: "朝阳市"}, {code: "0427", city: "盘锦市"}, {
        code: "0429",
        city: "葫芦岛市"
    }, {code: "0431", city: "长春市"}, {code: "0432", city: "吉林市"}, {
        code: "0433",
        city: "延边朝鲜族自治州"
    }, {code: "0434", city: "四平市"}, {code: "0435", city: "通化市"}, {code: "0437", city: "辽源市"}, {
        code: "0438",
        city: "松原市"
    }, {code: "0439", city: "白山市"}, {code: "0451", city: "哈尔滨市"}, {
        code: "0452",
        city: "齐齐哈尔市"
    }, {code: "0453", city: "牡丹江市"}, {code: "0453", city: "鸡西市"}, {
        code: "0453",
        city: "七台河市"
    }, {code: "0454", city: "鹤岗市"}, {code: "0454", city: "佳木斯市"}, {
        code: "0454",
        city: "双鸭山市"
    }, {code: "0456", city: "黑河市"}, {code: "0457", city: "大兴安岭地区"}, {
        code: "0458",
        city: "伊春市"
    }, {code: "0458", city: "绥化市"}, {code: "0459", city: "大庆市"}, {code: "025", city: "南京市"}, {
        code: "0510",
        city: "无锡市"
    }, {code: "0511", city: "镇江市"}, {code: "0512", city: "苏州市"}, {code: "0513", city: "南通市"}, {
        code: "0514",
        city: "扬州市"
    }, {code: "0515", city: "盐城市"}, {code: "0516", city: "徐州市"}, {code: "0517", city: "淮安市"}, {
        code: "0518",
        city: "连云港市"
    }, {code: "0519", city: "常州市"}, {code: "0523", city: "泰州市"}, {code: "0527", city: "宿迁市"}, {
        code: "0570",
        city: "衢州市"
    }, {code: "0571", city: "杭州市"}, {code: "0572", city: "湖州市"}, {code: "0573", city: "嘉兴市"}, {
        code: "0574",
        city: "宁波市"
    }, {code: "0575", city: "绍兴市"}, {code: "0576", city: "台州市"}, {code: "0577", city: "温州市"}, {
        code: "0578",
        city: "丽水市"
    }, {code: "0579", city: "金华市"}, {code: "0580", city: "舟山市"}, {code: "0550", city: "滁州市"}, {
        code: "0551",
        city: "合肥市"
    }, {code: "0552", city: "蚌埠市"}, {code: "0553", city: "芜湖市"}, {code: "0554", city: "淮南市"}, {
        code: "0555",
        city: "马鞍山市"
    }, {code: "0556", city: "安庆市"}, {code: "0557", city: "宿州市"}, {code: "0558", city: "亳州市"}, {
        code: "0558",
        city: "阜阳市"
    }, {code: "0559", city: "黄山市"}, {code: "0561", city: "淮北市"}, {code: "0562", city: "铜陵市"}, {
        code: "0563",
        city: "宣城市"
    }, {code: "0564", city: "六安市"}, {code: "0565", city: "巢湖市"}, {code: "0566", city: "池州市"}, {
        code: "0591",
        city: "福州市"
    }, {code: "0592", city: "厦门市"}, {code: "0593", city: "宁德市"}, {code: "0594", city: "莆田市"}, {
        code: "0595",
        city: "泉州市"
    }, {code: "0596", city: "漳州市"}, {code: "0597", city: "龙岩市"}, {code: "0598", city: "三明市"}, {
        code: "0599",
        city: "南平市"
    }, {code: "0701", city: "鹰潭市"}, {code: "0790", city: "新余市"}, {code: "0791", city: "南昌市"}, {
        code: "0792",
        city: "九江市"
    }, {code: "0793", city: "上饶市"}, {code: "0794", city: "抚州市"}, {code: "0795", city: "宜春市"}, {
        code: "0796",
        city: "吉安市"
    }, {code: "0797", city: "赣州市"}, {code: "0798", city: "景德镇市"}, {code: "0799", city: "萍乡市"}, {
        code: "0530",
        city: "菏泽市"
    }, {code: "0531", city: "济南市"}, {code: "0532", city: "青岛市"}, {code: "0533", city: "淄博市"}, {
        code: "0534",
        city: "德州市"
    }, {code: "0535", city: "烟台市"}, {code: "0536", city: "潍坊市"}, {code: "0537", city: "济宁市"}, {
        code: "0538",
        city: "泰安市"
    }, {code: "0539", city: "临沂市"}, {code: "0543", city: "滨州市"}, {code: "0546", city: "东营市"}, {
        code: "0631",
        city: "威海市"
    }, {code: "0632", city: "枣庄市"}, {code: "0633", city: "日照市"}, {code: "0634", city: "莱芜市"}, {
        code: "0635",
        city: "聊城市"
    }, {code: "0370", city: "商丘市"}, {code: "0371", city: "郑州市"}, {code: "0372", city: "安阳市"}, {
        code: "0373",
        city: "新乡市"
    }, {code: "0374", city: "许昌市"}, {code: "0375", city: "平顶山市"}, {code: "0376", city: "信阳市"}, {
        code: "0377",
        city: "南阳市"
    }, {code: "0378", city: "开封市"}, {code: "0379", city: "洛阳市"}, {code: "0391", city: "焦作市"}, {
        code: "0391",
        city: "济源市"
    }, {code: "0392", city: "鹤壁市"}, {code: "0393", city: "濮阳市"}, {code: "0394", city: "周口市"}, {
        code: "0395",
        city: "漯河市"
    }, {code: "0396", city: "驻马店市"}, {code: "0398", city: "三门峡市"}, {code: "027", city: "武汉市"}, {
        code: "0710",
        city: "襄樊市"
    }, {code: "0711", city: "鄂州市"}, {code: "0712", city: "孝感市"}, {code: "0713", city: "黄冈市"}, {
        code: "0714",
        city: "黄石市"
    }, {code: "0715", city: "咸宁市"}, {code: "0716", city: "荆州市"}, {code: "0717", city: "宜昌市"}, {
        code: "0718",
        city: "恩施土家族苗族自治州"
    }, {code: "0719", city: "十堰市"}, {code: "0719", city: "神农架林区"}, {
        code: "0722",
        city: "随州市"
    }, {code: "0727", city: "荆门市"}, {code: "0728", city: "潜江市"}, {code: "0728", city: "天门市"}, {
        code: "0728",
        city: "仙桃市"
    }, {code: "0730", city: "岳阳市"}, {code: "0731", city: "长沙市"}, {code: "0732", city: "湘潭市"}, {
        code: "0733",
        city: "株洲市"
    }, {code: "0734", city: "衡阳市"}, {code: "0735", city: "郴州市"}, {code: "0736", city: "常德市"}, {
        code: "0737",
        city: "益阳市"
    }, {code: "0738", city: "娄底市"}, {code: "0739", city: "邵阳市"}, {
        code: "0743",
        city: "湘西土家族苗族自治州"
    }, {code: "0744", city: "张家界市"}, {code: "0745", city: "怀化市"}, {code: "0746", city: "永州市"}, {
        code: "020",
        city: "广州市"
    }, {code: "0660", city: "汕尾市"}, {code: "0662", city: "阳江市"}, {code: "0663", city: "揭阳市"}, {
        code: "0668",
        city: "茂名市"
    }, {code: "0750", city: "江门市"}, {code: "0751", city: "韶关市"}, {code: "0752", city: "惠州市"}, {
        code: "0753",
        city: "梅州市"
    }, {code: "0754", city: "汕头市"}, {code: "0755", city: "深圳市"}, {code: "0756", city: "珠海市"}, {
        code: "0757",
        city: "佛山市"
    }, {code: "0758", city: "肇庆市"}, {code: "0759", city: "湛江市"}, {code: "0760", city: "中山市"}, {
        code: "0762",
        city: "河源市"
    }, {code: "0763", city: "清远市"}, {code: "0766", city: "云浮市"}, {code: "0768", city: "潮州市"}, {
        code: "0769",
        city: "东莞市"
    }, {code: "0770", city: "防城港市"}, {code: "0771", city: "崇左市"}, {code: "0771", city: "南宁市"}, {
        code: "0772",
        city: "来宾市"
    }, {code: "0772", city: "柳州市"}, {code: "0773", city: "桂林市"}, {code: "0774", city: "贺州市"}, {
        code: "0774",
        city: "梧州市"
    }, {code: "0775", city: "玉林市"}, {code: "0775", city: "贵港市"}, {code: "0776", city: "百色市"}, {
        code: "0777",
        city: "钦州市"
    }, {code: "0778", city: "河池市"}, {code: "0779", city: "北海市"}, {code: "0898", city: "万宁市"}, {
        code: "0898",
        city: "白沙黎族自治县"
    }, {code: "0898", city: "儋州市"}, {code: "0898", city: "琼海市"}, {code: "0898", city: "文昌市"}, {
        code: "0898",
        city: "澄迈县"
    }, {code: "0898", city: "屯昌县"}, {code: "0898", city: "定安县"}, {
        code: "0898",
        city: "陵水黎族自治县"
    }, {code: "0898", city: "五指山市"}, {code: "0898", city: "琼中黎族苗族自治县"}, {
        code: "0898",
        city: "昌江黎族自治县"
    }, {code: "0898", city: "乐东黎族自治县"}, {code: "0898", city: "三亚市"}, {
        code: "0898",
        city: "保亭黎族苗族自治县"
    }, {code: "0898", city: "海口市"}, {code: "0898", city: "东方市"}, {code: "0898", city: "临高县"}, {
        code: "028",
        city: "成都市"
    }, {code: "0812", city: "攀枝花市"}, {code: "0813", city: "自贡市"}, {code: "0816", city: "绵阳市"}, {
        code: "0817",
        city: "南充市"
    }, {code: "0818", city: "达州市"}, {code: "0825", city: "遂宁市"}, {code: "0826", city: "广安市"}, {
        code: "0827",
        city: "巴中市"
    }, {code: "0830", city: "泸州市"}, {code: "0831", city: "宜宾市"}, {code: "0832", city: "内江市"}, {
        code: "0832",
        city: "资阳市"
    }, {code: "0833", city: "眉山市"}, {code: "0833", city: "乐山市"}, {
        code: "0834",
        city: "凉山彝族自治州"
    }, {code: "0835", city: "雅安市"}, {code: "0836", city: "甘孜藏族自治州"}, {
        code: "0837",
        city: "阿坝藏族羌族自治州"
    }, {code: "0838", city: "德阳市"}, {code: "0839", city: "广元市"}, {code: "0851", city: "贵阳市"}, {
        code: "0852",
        city: "遵义市"
    }, {code: "0853", city: "安顺市"}, {code: "0854", city: "黔南布依族苗族自治州"}, {
        code: "0855",
        city: "黔东南苗族侗族自治州"
    }, {code: "0856", city: "铜仁地区"}, {code: "0857", city: "毕节地区"}, {
        code: "0858",
        city: "六盘水市"
    }, {code: "0867", city: "黔西南布依族苗族自治州"}, {code: "0691", city: "西双版纳傣族自治州"}, {
        code: "0692",
        city: "德宏傣族景颇族自治州"
    }, {code: "0870", city: "昭通市"}, {code: "0871", city: "昆明市"}, {
        code: "0872",
        city: "大理白族自治州"
    }, {code: "0873", city: "红河哈尼族彝族自治州"}, {code: "0874", city: "曲靖市"}, {
        code: "0875",
        city: "保山市"
    }, {code: "0876", city: "文山壮族苗族自治州"}, {code: "0877", city: "玉溪市"}, {
        code: "0878",
        city: "楚雄彝族自治州"
    }, {code: "0879", city: "普洱市"}, {code: "0883", city: "临沧市"}, {
        code: "0886",
        city: "怒江傈僳族自治州"
    }, {code: "0887", city: "迪庆藏族自治州"}, {code: "0888", city: "丽江市"}, {
        code: "0807",
        city: "阿里地区"
    }, {code: "0891", city: "拉萨市"}, {code: "0892", city: "日喀则地区"}, {
        code: "0893",
        city: "山南地区"
    }, {code: "0894", city: "林芝地区"}, {code: "0895", city: "昌都地区"}, {
        code: "0896",
        city: "那曲地区"
    }, {code: "029", city: "西安市"}, {code: "0910", city: "咸阳市"}, {code: "0911", city: "延安市"}, {
        code: "0912",
        city: "榆林市"
    }, {code: "0913", city: "渭南市"}, {code: "0914", city: "商洛市"}, {code: "0915", city: "安康市"}, {
        code: "0916",
        city: "汉中市"
    }, {code: "0917", city: "宝鸡市"}, {code: "0919", city: "铜川市"}, {
        code: "0930",
        city: "临夏回族自治州"
    }, {code: "0931", city: "兰州市"}, {code: "0932", city: "定西市"}, {code: "0935", city: "武威市"}, {
        code: "0935",
        city: "金昌市"
    }, {code: "0936", city: "张掖市"}, {code: "0937", city: "酒泉市"}, {code: "0937", city: "嘉峪关市"}, {
        code: "0938",
        city: "天水市"
    }, {code: "0939", city: "陇南市"}, {code: "0941", city: "甘南藏族自治州"}, {
        code: "0943",
        city: "白银市"
    }, {code: "0943", city: "平凉市"}, {code: "0944", city: "庆阳市"}, {
        code: "0970",
        city: "海北藏族自治州"
    }, {code: "0971", city: "西宁市"}, {code: "0972", city: "海东地区"}, {
        code: "0973",
        city: "黄南藏族自治州"
    }, {code: "0974", city: "海南藏族自治州"}, {code: "0975", city: "果洛藏族自治州"}, {
        code: "0976",
        city: "玉树藏族自治州"
    }, {code: "0979", city: "海西蒙古族藏族自治州"}, {code: "0951", city: "银川市"}, {
        code: "0952",
        city: "石嘴山市"
    }, {code: "0953", city: "中卫市"}, {code: "0953", city: "吴忠市"}, {code: "0954", city: "固原市"}, {
        code: "0901",
        city: "塔城地区"
    }, {code: "0902", city: "哈密地区"}, {code: "0903", city: "和田地区"}, {
        code: "0906",
        city: "阿勒泰地区"
    }, {code: "0908", city: "阿克苏地区"}, {code: "0908", city: "克孜勒苏柯尔克孜自治州"}, {
        code: "0909",
        city: "博尔塔拉蒙古自治州"
    }, {code: "0990", city: "克拉玛依市"}, {code: "0991", city: "乌鲁木齐市"}, {
        code: "0993",
        city: "石河子市"
    }, {code: "0994", city: "昌吉回族自治州"}, {code: "0995", city: "吐鲁番地区"}, {
        code: "0996",
        city: "巴音郭楞蒙古自治州"
    }, {code: "0997", city: "阿拉尔市"}, {code: "0998", city: "喀什地区"}, {
        code: "0998",
        city: "图木舒克市"
    }, {code: "0999", city: "伊犁哈萨克自治州"}],
    CODE_LIST: ["010", "022", "021", "023", "0310", "0311", "0312", "0313", "0314", "0315", "0316", "0317", "0318", "0319", "0335", "0349", "0350", "0351", "0352", "0353", "0354", "0355", "0356", "0357", "0358", "0359", "0470", "0471", "0472", "0473", "0475", "0476", "0477", "0478", "0479", "0482", "0482", "0483", "024", "0410", "0411", "0412", "0413", "0414", "0415", "0416", "0417", "0418", "0419", "0421", "0427", "0429", "0431", "0432", "0433", "0434", "0435", "0437", "0438", "0439", "0451", "0452", "0453", "0453", "0453", "0454", "0454", "0454", "0456", "0457", "0458", "0458", "0459", "025", "0510", "0511", "0512", "0513", "0514", "0515", "0516", "0517", "0518", "0519", "0523", "0527", "0570", "0571", "0572", "0573", "0574", "0575", "0576", "0577", "0578", "0579", "0580", "0550", "0551", "0552", "0553", "0554", "0555", "0556", "0557", "0558", "0558", "0559", "0561", "0562", "0563", "0564", "0565", "0566", "0591", "0592", "0593", "0594", "0595", "0596", "0597", "0598", "0599", "0701", "0790", "0791", "0792", "0793", "0794", "0795", "0796", "0797", "0798", "0799", "0530", "0531", "0532", "0533", "0534", "0535", "0536", "0537", "0538", "0539", "0543", "0546", "0631", "0632", "0633", "0634", "0635", "0370", "0371", "0372", "0373", "0374", "0375", "0376", "0377", "0378", "0379", "0391", "0391", "0392", "0393", "0394", "0395", "0396", "0398", "027", "0710", "0711", "0712", "0713", "0714", "0715", "0716", "0717", "0718", "0719", "0719", "0722", "0727", "0728", "0728", "0728", "0730", "0731", "0732", "0733", "0734", "0735", "0736", "0737", "0738", "0739", "0743", "0744", "0745", "0746", "020", "0660", "0662", "0663", "0668", "0750", "0751", "0752", "0753", "0754", "0755", "0756", "0757", "0758", "0759", "0760", "0762", "0763", "0766", "0768", "0769", "0770", "0771", "0771", "0772", "0772", "0773", "0774", "0774", "0775", "0775", "0776", "0777", "0778", "0779", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "0898", "028", "0812", "0813", "0816", "0817", "0818", "0825", "0826", "0827", "0830", "0831", "0832", "0832", "0833", "0833", "0834", "0835", "0836", "0837", "0838", "0839", "0851", "0852", "0853", "0854", "0855", "0856", "0857", "0858", "0867", "0691", "0692", "0870", "0871", "0872", "0873", "0874", "0875", "0876", "0877", "0878", "0879", "0883", "0886", "0887", "0888", "0807", "0891", "0892", "0893", "0894", "0895", "0896", "029", "0910", "0911", "0912", "0913", "0914", "0915", "0916", "0917", "0919", "0930", "0931", "0932", "0935", "0935", "0936", "0937", "0937", "0938", "0939", "0941", "0943", "0943", "0944", "0970", "0971", "0972", "0973", "0974", "0975", "0976", "0979", "0951", "0952", "0953", "0953", "0954", "0901", "0902", "0903", "0906", "0908", "0908", "0909", "0990", "0991", "0993", "0994", "0995", "0996", "0997", "0998", "0998", "0999",],

})


export const CODE_THEME = Object.freeze([
    {"name": "无障碍暗色", "value": "a11y-dark"},
    {"name": "无障碍亮色", "value": "a11y-light"},
    {"name": "玛瑙", "value": "agate"},
    {"name": "an-old-hope", "value": "an-old-hope"},
    {"name": "Android Studio风格", "value": "androidstudio"},
    {"name": "蚂蚁设计", "value": "ant-design"},
    {"name": "Arduino亮色", "value": "arduino-light"},
    {"name": "阿尔塔", "value": "arta"},
    {"name": "苦修", "value": "ascetic"},
    {"name": "原子暗色", "value": "atom-one-dark"},
    {"name": "原子暗色合理", "value": "atom-one-dark-reasonable"},
    {"name": "原子亮色", "value": "atom-one-light"},
    {"name": "棕色纸张", "value": "brown-paper"},
    {"name": "代码笔嵌入", "value": "codepen-embed"},
    {"name": "颜色酿造", "value": "color-brewer"},
    {"name": "暗色", "value": "dark"},
    {"name": "默认", "value": "default"},
    {"name": "设备豆", "value": "devibeans"},
    {"name": "多克科", "value": "docco"},
    {"name": "远", "value": "far"},
    {"name": "费利佩", "value": "felipec"},
    {"name": "基金会", "value": "foundation"},
    {"name": "github", "value": "github"},
    {"name": "github暗色", "value": "github-dark"},
    {"name": "github暗淡", "value": "github-dark-dimmed"},
    {"name": "gml", "value": "gml"},
    {"name": "谷歌代码", "value": "googlecode"},
    {"name": "暗色渐变", "value": "gradient-dark"},
    {"name": "亮色渐变", "value": "gradient-light"},
    {"name": "灰度", "value": "grayscale"},
    {"name": "混合", "value": "hybrid"},
    {"name": "理念", "value": "idea"},
    {"name": "IntelliJ亮色", "value": "intellij-light"},
    {"name": "ir黑色", "value": "ir-black"},
    {"name": "isbl编辑器暗色", "value": "isbl-editor-dark"},
    {"name": "isbl编辑器亮色", "value": "isbl-editor-light"},
    {"name": "kimbie暗色", "value": "kimbie-dark"},
    {"name": "kimbie亮色", "value": "kimbie-light"},
    {"name": "lightfair", "value": "lightfair"},
    {"name": "李欧", "value": "lioshi"},
    {"name": "玛古拉", "value": "magula"},
    {"name": "单蓝", "value": "mono-blue"},
    {"name": "单色", "value": "monokai"},
    {"name": "单色卓越", "value": "monokai-sublime"},
    {"name": "夜枭", "value": "night-owl"},
    {"name": "nnfx暗色", "value": "nnfx-dark"},
    {"name": "nnfx亮色", "value": "nnfx-light"},
    {"name": "北方", "value": "nord"},
    {"name": "黑曜石", "value": "obsidian"},
    {"name": "熊猫语法暗色", "value": "panda-syntax-dark"},
    {"name": "熊猫语法亮色", "value": "panda-syntax-light"},
    {"name": "帕拉伊索暗色", "value": "paraiso-dark"},
    {"name": "帕拉伊索亮色", "value": "paraiso-light"},
    {"name": "纯碱", "value": "pojoaque"},
    {"name": "purebasic", "value": "purebasic"},
    {"name": "qtcreator暗色", "value": "qtcreator-dark"},
    {"name": "qtcreator亮色", "value": "qtcreator-light"},
    {"name": "彩虹", "value": "rainbow"},
    {"name": "路由器操作系统", "value": "routeros"},
    {"name": "学校书", "value": "school-book"},
    {"name": "紫色阴影", "value": "shades-of-purple"},
    {"name": "srcery", "value": "srcery"},
    {"name": "堆栈溢出暗色", "value": "stackoverflow-dark"},
    {"name": "堆栈溢出亮色", "value": "stackoverflow-light"},
    {"name": "太阳爆发", "value": "sunburst"},
    {"name": "东京之夜暗色", "value": "tokyo-night-dark"},
    {"name": "东京之夜亮色", "value": "tokyo-night-light"},
    {"name": "明天晚上蓝色", "value": "tomorrow-night-blue"},
    {"name": "明天晚上明亮", "value": "tomorrow-night-bright"},
    {"name": "vs", "value": "vs"},
    {"name": "vs2015", "value": "vs2015"},
    {"name": "xcode", "value": "xcode"},
    {"name": "xt256", "value": "xt256"},


    {"name": "3024", "value": "base16/3024"},
    {"name": "冷漠", "value": "base16/apathy"},
    {"name": "学徒", "value": "base16/apprentice"},
    {"name": "灰烬", "value": "base16/ashes"},
    {"name": "工作室洞穴", "value": "base16/atelier-cave"},
    {"name": "工作室洞穴亮色", "value": "base16/atelier-cave-light"},
    {"name": "工作室沙丘", "value": "base16/atelier-dune"},
    {"name": "工作室沙丘亮色", "value": "base16/atelier-dune-light"},
    {"name": "工作室河口", "value": "base16/atelier-estuary"},
    {"name": "工作室河口亮色", "value": "base16/atelier-estuary-light"},
    {"name": "工作室森林", "value": "base16/atelier-forest"},
    {"name": "工作室森林亮色", "value": "base16/atelier-forest-light"},
    {"name": "工作室荒野", "value": "base16/atelier-heath"},
    {"name": "工作室荒野亮色", "value": "base16/atelier-heath-light"},
    {"name": "工作室湖畔", "value": "base16/atelier-lakeside"},
    {"name": "工作室湖畔亮色", "value": "base16/atelier-lakeside-light"},
    {"name": "工作室高原", "value": "base16/atelier-plateau"},
    {"name": "工作室高原亮色", "value": "base16/atelier-plateau-light"},
    {"name": "工作室稀树草原", "value": "base16/atelier-savanna"},
    {"name": "工作室稀树草原亮色", "value": "base16/atelier-savanna-light"},
    {"name": "工作室海边", "value": "base16/atelier-seaside"},
    {"name": "工作室海边亮色", "value": "base16/atelier-seaside-light"},
    {"name": "工作室硫磺池", "value": "base16/atelier-sulphurpool"},
    {"name": "工作室硫磺池亮色", "value": "base16/atelier-sulphurpool-light"},
    {"name": "地图集", "value": "base16/atlas"},
    {"name": "bespin", "value": "base16/bespin"},
    {"name": "黑色金属", "value": "base16/black-metal"},
    {"name": "黑色金属-巴托里", "value": "base16/black-metal-bathory"},
    {"name": "黑色金属-burzum", "value": "base16/black-metal-burzum"},
    {"name": "黑色金属-黑暗葬礼", "value": "base16/black-metal-dark-funeral"},
    {"name": "黑色金属-戈尔戈斯", "value": "base16/black-metal-gorgoroth"},
    {"name": "黑色金属-不朽", "value": "base16/black-metal-immortal"},
    {"name": "黑色金属-khold", "value": "base16/black-metal-khold"},
    {"name": "黑色金属-马杜克", "value": "base16/black-metal-marduk"},
    {"name": "黑色金属-五月天", "value": "base16/black-metal-mayhem"},
    {"name": "黑色金属-尼罗河", "value": "base16/black-metal-nile"},
    {"name": "黑色金属-毒液", "value": "base16/black-metal-venom"},
    {"name": "布鲁尔", "value": "base16/brewer"},
    {"name": "明亮", "value": "base16/bright"},
    {"name": "编程高手", "value": "base16/brogrammer"},
    {"name": "画笔树", "value": "base16/brush-trees"},
    {"name": "画笔树暗色", "value": "base16/brush-trees-dark"},
    {"name": "粉笔", "value": "base16/chalk"},
    {"name": "马戏团", "value": "base16/circus"},
    {"name": "经典暗色", "value": "base16/classic-dark"},
    {"name": "经典亮色", "value": "base16/classic-light"},
    {"name": "代码学校", "value": "base16/codeschool"},
    {"name": "颜色", "value": "base16/colors"},
    {"name": "纸杯蛋糕", "value": "base16/cupcake"},
    {"name": "cupertino", "value": "base16/cupertino"},
    {"name": "丹青", "value": "base16/danqing"},
    {"name": "darcula", "value": "base16/darcula"},
    {"name": "深紫色", "value": "base16/dark-violet"},
    {"name": "暗苔藓", "value": "base16/darkmoss"},
    {"name": "暗牙", "value": "base16/darktooth"},
    {"name": "脱咖啡因", "value": "base16/decaf"},
    {"name": "默认暗色", "value": "base16/default-dark"},
    {"name": "默认亮色", "value": "base16/default-light"},
    {"name": "肮脏的海", "value": "base16/dirtysea"},
    {"name": "德古拉", "value": "base16/dracula"},
    {"name": "边缘暗色", "value": "base16/edge-dark"},
    {"name": "边缘亮色", "value": "base16/edge-light"},
    {"name": "八十年代", "value": "base16/eighties"},
    {"name": "余烬", "value": "base16/embers"},
    {"name": "平衡暗色", "value": "base16/equilibrium-dark"},
    {"name": "平衡灰暗", "value": "base16/equilibrium-gray-dark"},
    {"name": "平衡亮色", "value": "base16/equilibrium-light"},
    {"name": "浓缩咖啡", "value": "base16/espresso"},
    {"name": "伊娃", "value": "base16/eva"},
    {"name": "伊娃暗淡", "value": "base16/eva-dim"},
    {"name": "扁平", "value": "base16/flat"},
    {"name": "框架工", "value": "base16/framer"},
    {"name": "果味苏打", "value": "base16/fruit-soda"},
    {"name": "千兆伏", "value": "base16/gigavolt"},
    {"name": "github", "value": "base16/github"},
    {"name": "谷歌暗色", "value": "base16/google-dark"},
    {"name": "谷歌亮色", "value": "base16/google-light"},
    {"name": "灰度暗色", "value": "base16/grayscale-dark"},
    {"name": "灰度亮色", "value": "base16/grayscale-light"},
    {"name": "绿屏", "value": "base16/green-screen"},
    {"name": "gruvbox暗硬", "value": "base16/gruvbox-dark-hard"},
    {"name": "gruvbox暗中", "value": "base16/gruvbox-dark-medium"},
    {"name": "gruvbox暗淡", "value": "base16/gruvbox-dark-pale"},
    {"name": "gruvbox暗软", "value": "base16/gruvbox-dark-soft"},
    {"name": "gruvbox亮硬", "value": "base16/gruvbox-light-hard"},
    {"name": "gruvbox亮中", "value": "base16/gruvbox-light-medium"},
    {"name": "gruvbox亮淡", "value": "base16/gruvbox-light-soft"},
    {"name": "硬核", "value": "base16/hardcore"},
    {"name": "harmonic16暗色", "value": "base16/harmonic16-dark"},
    {"name": "harmonic16亮色", "value": "base16/harmonic16-light"},
    {"name": "heetch暗色", "value": "base16/heetch-dark"},
    {"name": "heetch亮色", "value": "base16/heetch-light"},
    {"name": "太阳神", "value": "base16/helios"},
    {"name": "跳房子", "value": "base16/hopscotch"},
    {"name": "地平线暗色", "value": "base16/horizon-dark"},
    {"name": "地平线亮色", "value": "base16/horizon-light"},
    {"name": "类人暗色", "value": "base16/humanoid-dark"},
    {"name": "类人亮色", "value": "base16/humanoid-light"},
    {"name": "ia暗色", "value": "base16/ia-dark"},
    {"name": "ia亮色", "value": "base16/ia-light"},
    {"name": "冰冷暗色", "value": "base16/icy-dark"},
    {"name": "ir黑色", "value": "base16/ir-black"},
    {"name": "同位素", "value": "base16/isotope"},
    {"name": "kimber", "value": "base16/kimber"},
    {"name": "伦敦地铁", "value": "base16/london-tube"},
    {"name": "麦金塔", "value": "base16/macintosh"},
    {"name": "马拉喀什", "value": "base16/marrakesh"},
    {"name": "materia", "value": "base16/materia"},
    {"name": "material", "value": "base16/material"},
    {"name": "material-darker", "value": "base16/material-darker"},
    {"name": "material-lighter", "value": "base16/material-lighter"},
    {"name": "material-palenight", "value": "base16/material-palenight"},
    {"name": "material-vivid", "value": "base16/material-vivid"},
    {"name": "柔和紫色", "value": "base16/mellow-purple"},
    {"name": "墨西哥亮色", "value": "base16/mexico-light"},
    {"name": "摩卡", "value": "base16/mocha"},
    {"name": "单色", "value": "base16/monokai"},
    {"name": "星云", "value": "base16/nebula"},
    {"name": "nord", "value": "base16/nord"},
    {"name": "nova", "value": "base16/nova"},
    {"name": "海洋", "value": "base16/ocean"},
    {"name": "oceanicnext", "value": "base16/oceanicnext"},
    {"name": "one-light", "value": "base16/one-light"},
    {"name": "onedark", "value": "base16/onedark"},
    {"name": "outrun-dark", "value": "base16/outrun-dark"},
    {"name": "papercolor暗色", "value": "base16/papercolor-dark"},
    {"name": "papercolor亮色", "value": "base16/papercolor-light"},
    {"name": "paraiso", "value": "base16/paraiso"},
    {"name": "pasque", "value": "base16/pasque"},
    {"name": "phd", "value": "base16/phd"},
    {"name": "pico", "value": "base16/pico"},
    {"name": "pop", "value": "base16/pop"},
    {"name": "porple", "value": "base16/porple"},
    {"name": "qualia", "value": "base16/qualia"},
    {"name": "railscasts", "value": "base16/railscasts"},
    {"name": "rebecca", "value": "base16/rebecca"},
    {"name": "ros-pine", "value": "base16/ros-pine"},
    {"name": "ros-pine-dawn", "value": "base16/ros-pine-dawn"},
    {"name": "ros-pine-moon", "value": "base16/ros-pine-moon"},
    {"name": "sagelight", "value": "base16/sagelight"},
    {"name": "sandcastle", "value": "base16/sandcastle"},
    {"name": "seti-ui", "value": "base16/seti-ui"},
    {"name": "shapeshifter", "value": "base16/shapeshifter"},
    {"name": "silk-dark", "value": "base16/silk-dark"},
    {"name": "silk-light", "value": "base16/silk-light"},
    {"name": "snazzy", "value": "base16/snazzy"},
    {"name": "solar-flare", "value": "base16/solar-flare"},
    {"name": "solar-flare-light", "value": "base16/solar-flare-light"},
    {"name": "solarized-dark", "value": "base16/solarized-dark"},
    {"name": "solarized-light", "value": "base16/solarized-light"},
    {"name": "spacemacs", "value": "base16/spacemacs"},
    {"name": "summercamp", "value": "base16/summercamp"},
    {"name": "summerfruit-dark", "value": "base16/summerfruit-dark"},
    {"name": "summerfruit-light", "value": "base16/summerfruit-light"},
    {"name": "synth-midnight-terminal-dark", "value": "base16/synth-midnight-terminal-dark"},
    {"name": "synth-midnight-terminal-light", "value": "base16/synth-midnight-terminal-light"},
    {"name": "tango", "value": "base16/tango"},
    {"name": "tender", "value": "base16/tender"},
    {"name": "tomorrow", "value": "base16/tomorrow"},
    {"name": "tomorrow-night", "value": "base16/tomorrow-night"},
    {"name": "twilight", "value": "base16/twilight"},
    {"name": "unikitty-dark", "value": "base16/unikitty-dark"},
    {"name": "unikitty-light", "value": "base16/unikitty-light"},
    {"name": "vulcan", "value": "base16/vulcan"},
    {"name": "windows-10", "value": "base16/windows-10"},
    {"name": "windows-10-light", "value": "base16/windows-10-light"},
    {"name": "windows-95", "value": "base16/windows-95"},
    {"name": "windows-95-light", "value": "base16/windows-95-light"},
    {"name": "windows-high-contrast", "value": "base16/windows-high-contrast"},
    {"name": "windows-high-contrast-light", "value": "base16/windows-high-contrast-light"},
    {"name": "windows-nt", "value": "base16/windows-nt"},
    {"name": "windows-nt-light", "value": "base16/windows-nt-light"},
    {"name": "woodland", "value": "base16/woodland"},
    {"name": "xcode-dusk", "value": "base16/xcode-dusk"},
    {"name": "zenburn", "value": "base16/zenburn"}
])

export class SubmitType {
    static commit = "/commit";
    static modified = "/modified";
}

export class TagType {
    static DEFAULT = "DEFAULT";
    static DOCUMENT = "DOCUMENT";
    static INFO = "INFO";
    static INFO_SOURCE = "INFO_SOURCE";
    static CUSTOM_INFO = "CUSTOM_INFO";
    static SYSTEM = "SYSTEM";
    static USER = "USER";
    static BUSINESS_DOMAIN = "BUSINESS_DOMAIN";
    static INFO_TYPE = "INFO_TYPE";

    static INFO_CATEGORY = "INFO_CATEGORY";
    static NEAR_BY = "NEAR_BY";
}

/**
 * @Author: Evan.LJ
 * @Description: 正则表达式的相关类
 * @FullName: Constant.js
 */
export const REGEXPS = Object.freeze({
    SIZE_UNIT: /^([+-]?\d*\.?\d+)(px|em|rem|%|vh|vw|vmin|vmax|ex|ch|in|cm|mm|pt|pc)$/i,
    HTTP: /^(?:(http|https|ftp):\/\/)?((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/i,
    //通用账号
    ACCOUNT: /^OTSIF_[A-Za-z0-9]{10,20}$|^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$|^1[3-9]\d{9}$|^(?!OTSIF_)(?=[a-zA-Z0-9_]*[\u4e00-\u9fa5])[\u4e00-\u9fa5a-zA-Z0-9_]{4,16}$/,
    //匹配本系统的用户ID
    OTSIF_ID: /^OTSIF_[A-Za-z0-9]{10,20}$/,
    //验证码正则（混合）
    VERIFY_CODE: /^[a-zA-Z0-9]{6,8}$/,
    //验证码正则(手机号）
    VERIFY_CODE_NUMBER: /^[0-9]{6}$/,
    //验证码正则（邮箱号）
    VERIFY_CODE_LETTER: /^[a-zA-Z0-9]{8}$/,
    //手机号正则
    PHONE: /^1[3-9]\d{9}$/,
    TEL: /^(1[3-9]\d{9}|0[1-9][0-9]{1,2}-[2-8][0-9]{6,7})$/,
    FIXED_PHONE: /^0[1-9][0-9]{1,2}-[2-8][0-9]{6,7}$/,
    //角色正则
    ROLE: /^(guide|default)$/,
    //邮箱正则
    EMAIL:
        /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/,
    //邮箱或手机号
    PHONE_OR_EMAIL:
        /^1[3-9]\d{9}|([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/,
    //银行卡正则
    BANK_CARD: /^([1-9]{1})(\d{14}|\d{18})$/,
    //密码正则(总长度8~20位，至少包含数字、字母、特殊字符中的两种)
    PASSWORD:
        /^((?=.*[a-z])((?=.*[A-Z])|(?=.*\d)|(?=.*[^a-zA-Z0-9]))|(?=.*[A-Z])((?=.*[a-z])|(?=.*\d)|(?=.*[^a-zA-Z0-9]))|(?=.*[\d])((?=.*[a-z])|(?=.*[A-Z])|(?=.*[^a-zA-Z0-9]))).{8,20}$/,
    PASSWORD_NOT_LENGTH: /^((?=.*[a-z])((?=.*[A-Z])|(?=.*\d)|(?=.*[^a-zA-Z0-9]))|(?=.*[A-Z])((?=.*[a-z])|(?=.*\d)|(?=.*[^a-zA-Z0-9]))|(?=.*[\d])((?=.*[a-z])|(?=.*[A-Z])|(?=.*[^a-zA-Z0-9]))).+$/,
    //邮编正则
    ZIP_CODE: /^[1-9]\d{5}(?!\d)$/,
    //营业执照（统一社会信用代码）正则
    BUSINESS_CARD: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
    //中文正则
    CH: /^[\u4e00-\u9fa5]*$/,
    //英文正则
    EN: /^[a-zA-Z]*$/,
    CH_AND_EN: /^[a-zA-Z\u4e00-\u9fa5()（）]*$/,
    //数字正则
    NUM: /^[0-9]+$/,
    FLOAT: /^\d+(\.\d)?$/,
    //字母数字正则
    LETTER_NUM: /^[a-zA-Z0-9]+$/,
    //字母数字下划线正则
    LETTER_NUM_UNDERLINE: /^[a-zA-Z0-9_]+$/,
    //字母数字下划线中划线正则
    LETTER_NUM_UNDERLINE_STRIKE: /^[a-zA-Z0-9_-]*$/,
    //字母数字下划线中划线点正则
    LETTER_NUM_UNDERLINE_STRIKE_DOT: /^[a-zA-Z0-9_.-]*$/,
    //字母数字下划线中划线点正反斜杠正则
    LETTER_NUM_UNDERLINE_STRIKE_DOT_SLASH: /^[a-zA-Z0-9_.-/]*$/,
    //用户名正则(字母数字下划线中划线点正反斜杠正则)
    USERNAME: /^[a-zA-Z0-9_-]{4,16}$/,
    //姓名正则（中文名、英文名、复姓）
    NAME: /^([\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*|[A-Za-z]+([-']?[A-Za-z]+)*\s+[A-Za-z]+([-']?[A-Za-z]+)*)$/,
    //身份证正则
    ID_CARD: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)?$/,
    //用户名正则(字母数字下划线中划线中文正则)
    CHINESE_USERNAME: /^(?!OTSIF_)(?=[a-zA-Z0-9_]*[\u4e00-\u9fa5])[\u4e00-\u9fa5a-zA-Z0-9_]{4,16}$/,
    //日期正则
    DATE: /^(\d{4})-(\d{2})-(\d{2})$/,
    //时间正则
    TIME: /^(2[0-3]|[01]+[0-9]):([0-5]+[0-9])$/,
    //日期时间正则
    DATETIME: /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
})


// export const NAVIGATE_MODE = Object.freeze([
//     Object.freeze({
//         INDEX: 0,
//         NAME: '打开',
//         ICON: 'icon-baidu-map',
//         FUNCTIONS:function (point, location) {
//             console.log(point,location)
//             //定位
//             var url = `https://map.baidu.com/search/${location}/@12519129.85,4088448.61,12z?querytype=s&addr=0&wd=${location}&eqid=d80b8c810000eaac000000065f3d71e2&dest=Latlng:${point}&destType=0&src=0&c=153&pn=0&device_ratio=1&da_src=shareurl`
//             window.open(url);
//         }
//     }),
//     Object.freeze({
//         INDEX: 1,
//         NAME: '公交',
//         ICON: 'icon-bus',
//         FUNCTIONS:function (point, location) {
//             console.log(point,location)
//             //公交出行
//             var url = `https://map.baidu.com/dir/我的位置/${location}/@12509352.534912042,4080651.8,12.4z?querytype=bt&c=153&sn=1$$$$12517967.863871781,4098574.197040837$$我的位置$$0$$$$&en=1$$e98c0f3f80c2e17130169bac$$12517403,4062733$$${location}$$0$$$$&sc=153&ec=153&pn=0&rn=5&exptype=dep&exptime=2024-08-26%2022:48&version=5&da_src=shareurl`;
//             window.open(url);
//         }
//     }),
//     Object.freeze({
//         INDEX: 2,
//         NAME: '驾车',
//         ICON: 'icon-car',
//         FUNCTIONS:function (point,location) {
//             console.log(point,location)
//             //驾车导航
//             var url = `https://map.baidu.com/dir/我的位置/${location}/@12506984.136643132,4080152.2649999997,12.43z?querytype=nav&c=153&sn=1$$$$12517969.101984933,4098572.4372594687$$我的位置$$0$$$$&en=0$$e98c0f3f80c2e17130169bac$$12517431.19,4062751.00$$${location}$$0$$$$&sc=153&ec=153&pn=0&rn=5&mrs=1&version=4&route_traffic=1&sy=0&da_src=shareurl`
//             window.open(url);
//         }
//     }),
//     Object.freeze({
//         INDEX: 3,
//         NAME: '步行',
//         ICON: 'icon-walk',
//         FUNCTIONS:function (point, location) {
//             console.log(point,location)
//             //步行导航
//             var url = `https://map.baidu.com/dir/我的位置/${location}/@12509956.59178434,4080664.5,12.48z?querytype=walk&c=153&sn=1$$$$12517960.37589816,4098586.474432701$$我的位置$$0$$$$&en=1$$e98c0f3f80c2e17130169bac$$12517430.18,4062750.19$$${location}$$0$$$$&sc=153&ec=153&pn=0&rn=5&version=6&run=0&spath_type=1&da_src=shareurl`
//             window.open(url);
//         }
//     }),
//     Object.freeze({
//         INDEX: 4,
//         NAME: '骑行',
//         ICON: 'icon-bike',
//         FUNCTIONS:function (point, location) {
//             console.log(point,location)
//             //骑行导航
//             var url = `https://map.baidu.com/dir/我的位置/${location}/@12510225.702182287,4080511.5,12.46z?querytype=cycle&c=153&sn=1$$$$12517960.37589816,4098586.474432701$$我的位置$$0$$$$&en=1$$e98c0f3f80c2e17130169bac$$12517403,4062733$$${location}$$0$$$$&sc=153&ec=153&pn=0&rn=5&version=6&vehicle=0&spath_type=1&da_src=shareurl`
//             window.open(url);
//         }
//     }),
//
// ])

export const LINE = '-------------------------';

// 百度地图导航模式常量集合
export const NAVIGATE_MODE = Object.freeze([
    Object.freeze({
        INDEX: 0,
        NAME: '打开',
        ICON: 'icon-baidu-map',
        FUNCTIONS: function (point, location) {
            let p = {};
            if (typeof point === 'string') {
                var strings = point.split(',');
                p.lng = strings[0];
                p.lat = strings[1];
            } else {
                p = point;
            }
            //lng经度,lat纬度
            const link = `http://api.map.baidu.com/marker?location=${p.lat},${p.lng}&title=我的位置&content=${location}&output=html`;
            // 地点详情页URL
            window.open(link);
        }
    }),
    Object.freeze({
        INDEX: 1,
        NAME: '公交',
        ICON: 'icon-bus',
        FUNCTIONS: function (point, location) {
            // 生成当前时间
            const now = new Date();
            const dateStr = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
            const timeStr = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;

            // 公交导航URL
            const url = `https://map.baidu.com/dir/我的位置/${encodeURIComponent(location)}/` +
                `@${point[0]},${point[1]},12.4z?querytype=bt&` +
                `sn=1$$$$12517967.863871781,4098574.197040837$$我的位置$$0$$$$&` +
                `en=1$$${this.getPoiUid(location)}$$${point.join(',')}$$${location}$$0$$$$&` +
                `exptype=dep&exptime=${dateStr}%20${timeStr}&` +
                `version=5&da_src=shareurl&sc=153&ec=153`;
            window.open(url);
        }
    }),
    Object.freeze({
        INDEX: 2,
        NAME: '驾车',
        ICON: 'icon-car',
        FUNCTIONS: function (point, location) {
            let p = {};
            if (typeof point === 'string') {
                var strings = point.split(',');
                p.lng = strings[0];
                p.lat = strings[1];
            } else {
                p = point
            }
            //lng经度,lat纬度
            // 驾车导航URL
            const url = `https://map.baidu.com/dir/我的位置/${location}/@${p.lng},${p.lat},13.46z?querytype=nav&c=153&sn=1$$$$000000,000000$$我的位置$$0$$$$&en=0$$9fbfeef2dd79ea45ede4a550$$${p.lng},${p.lat}$$${location}$$0$$$$&sc=153&ec=153&pn=0&rn=5&mrs=1&version=4&route_traffic=1&sy=0&da_src=shareurl`;
            window.open(url);
        }
    }),
    Object.freeze({
        INDEX: 3,
        NAME: '步行',
        ICON: 'icon-walk',
        FUNCTIONS: function (point, location) {
            // 步行导航URL
            const url = `https://map.baidu.com/dir/我的位置/${encodeURIComponent(location)}/` +
                `@${point[0]},${point[1]},12.48z?querytype=walk&` +
                `sn=1$$$$12517960.37589816,4098586.474432701$$我的位置$$0$$$$&` +
                `en=1$$${this.getPoiUid(location)}$$${point.join(',')}$$${location}$$0$$$$&` +
                `version=6&run=0&spath_type=1&da_src=shareurl`;
            window.open(url);
        }
    }),
    Object.freeze({
        INDEX: 4,
        NAME: '骑行',
        ICON: 'icon-bike',
        FUNCTIONS: function (point, location) {
            // 骑行导航URL
            const url = `https://map.baidu.com/dir/我的位置/${encodeURIComponent(location)}/` +
                `@${point[0]},${point[1]},12.46z?querytype=cycle&` +
                `sn=1$$$$12517960.37589816,4098586.474432701$$我的位置$$0$$$$&` +
                `en=1$$${this.getPoiUid(location)}$$${point.join(',')}$$${location}$$0$$$$&` +
                `version=6&vehicle=0&spath_type=1&da_src=shareurl`;
            window.open(url);
        }
    }),

    // 公共工具方法
    Object.freeze({
        // 获取POI的UID（简化版）
        getPoiUid: function (location) {
            // 实际应用中这里可能需要根据位置名称查询真实UID
            // 此处使用模拟UID生成
            return this.hashCode(location).toString(16);
        },

        // 生成字符串的简单哈希值
        hashCode: function (str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = (hash << 5) - hash + str.charCodeAt(i);
                hash |= 0; // 转换为32位整数
            }
            return hash;
        },

        // 计算中心点坐标（起点和终点的中间点）
        calculateCenterPoint: function (startPoint, endPoint) {
            return [
                (startPoint[0] + endPoint[0]) / 2,
                (startPoint[1] + endPoint[1]) / 2
            ];
        }
    })
]);


export const LINE_NAME = [
    {
        label: '周边游',
        children: [

            {
                label: '老君山两日游', subLabel: '35-65座大巴车(车型随机)',
                day: 2,
                tags: [{value: '周边游', type: 'primary'}, {value: '深度游', type: 'danger'}],
                image:CommonFunction.generateGithubImageUrl('老君山两日游.jpg')
            },
            {
                label: '老君山一日游-早班',
                subLabel: '35-65座大巴车(车型随机)',
                day: 1,
                tags: '早去早回',
                description: '🧡早班：\n' +
                    'ℹ️出发时间：06:50火车站附近、07:10应天门附近、07:30国宝大厦东门、07:40高铁站附近\n' +
                    'ℹ️返程时间：16:00～16:30左右，约19:00到市区\n' +
                    'ℹ️车型：35~63座大巴车(车型随机)',
                image: CommonFunction.generateGithubImageUrl('老君山.jpg')
            },
            {
                label: '老君山一日游-中班', subLabel: '35-65座大巴车(车型随机)', day: 1, description: '🩷中班：\n' +
                    'ℹ️出发时间：08:50火车站附近、09:10丽景门附近、09:40高铁站附近\n' +
                    'ℹ️返程时间：19:00～20:00左右，约22:30左右到市区\n' +
                    'ℹ️车型：35~63座大巴车(车型随机)',
                image:CommonFunction.generateGithubImageUrl('老君山.jpg')
            },
            {
                label: '老君山一日游-晚班',
                subLabel: '35-65座大巴车(车型随机)',
                day: 1,
                tags: '晚去晚回',
                description: '🩷晚班：\n' +
                    'ℹ️出发时间：09:50火车站附近、10:10丽景门附近、10:40高铁站附近\n' +
                    'ℹ️返程时间：20:00～20:30左右，约23:00左右到市区\n' +
                    'ℹ️车型：35~63座大巴车(车型随机)',
                image:CommonFunction.generateGithubImageUrl('老君山.jpg')
            },
            {
                label: '老君山一日游-夜爬', subLabel: '35-65座大巴车(车型随机)', day: 1,description: '🩷夜爬：\n' +
                    'ℹ️出发时间：当日18:00火车站附近、19:10丽景门附近、19:30国宝大厦东门附近、19:40高铁站附近\n' +
                    'ℹ️返程时间：次日早07:001左右，约次日11:00左右到市区\n' +
                    'ℹ️车型：35~63座大巴车(车型随机)',
                image: CommonFunction.generateGithubImageUrl('老君山.jpg'),
                disabled:true
            },
            {
                label: '老君山一日游-小车15人团', subLabel: '市区范围内免费上门接送', day: 1,description: '🩷小车团：\n' +
                    'ℹ️出发时间：早09:30~10:00左右开始按规划顺序接站，具体时间以导游通知为准，市区范围内免费上门接送\n' +
                    'ℹ️返程时间：冬季20:30，夏季21:00，具体时间以下线咨询答复为准\n' +
                    'ℹ️车型：19~22座中巴车(车型随机)',
                image:CommonFunction.generateGithubImageUrl('老君山15人.jpg')
            },
            {label: '龙门+白马寺+洛博一日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('龙白博.jpg')},
            {label: '龙门+少林一日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('龙门少林.jpg')},
            {label: '白马寺+少林一日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('白马少林.jpg')},
            {label: '少林寺半日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('少林寺.jpg')},
            {label: '少林寺+三皇寨一日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('少林寺三皇寨.jpg')},
            {label: '白云山一日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('白云山.jpg')},
            {label: '龙潭峡一日游', day: 1,
                image: CommonFunction.generateGithubImageUrl('龙潭峡.jpg')},
        ]
    }, {
        label: '精品行程',
        children: [
            {label: '老君山一日游-15人', subname: '', day: 1,
                image: CommonFunction.generateGithubImageUrl('老君山15人.jpg')},
            {label: '三景洛行2-8人',
                tags: [{value: '一日游', type: 'primary'}, {value: '8人团', type: 'danger'}, {value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('三景洛行2-8人.jpg')},
            {label: '全景神都4天3晚15人',day: 4,
                tags: [{value: '四钻酒店', type: 'primary'},{value: '可升级', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '少林寺', type: 'success'},{value: '老君山', type: 'success'},{value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('全景神都4天3晚15人.jpg')},
            {label: '全景神都4天3晚2-8人',day: 4,
                tags: [{value: '四钻酒店', type: 'primary'},{value: '可升级', type: 'primary'}, {value: '8人团', type: 'danger'}, {value: '少林寺', type: 'success'},{value: '老君山', type: 'success'},{value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('全景神都4天3晚2-8人.jpg')},
            {label: '千年洛城3天2晚15人',day: 3,
                tags: [{value: '四钻酒店', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '少林寺', type: 'success'}, {value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('千年洛城3天2晚15人.jpg')},
            {label: '千年洛城3天2晚2-8人',day: 3,
                tags: [{value: '四钻酒店', type: 'primary'}, {value: '8人团', type: 'danger'}, {value: '少林寺', type: 'success'}, {value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('千年洛城3天2晚2-8人.jpg')},
            {label: '古都国色15人',day: 1,
                tags: [{value: '一日游', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('古都国色15人.jpg')},
            {label: '唐风魏骨2-8人',day: 1,
                tags: [{value: '一日游', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '龙门石窟', type: 'success'}, {value: '少林寺', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('唐风魏骨2-8人.jpg')},
            {label: '少林寺15人',day: 1,
                tags: [{value: '一日游', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '少林寺', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('少林寺15人.jpg')},
            {label: '锦绣洛阳3天2晚15人',day: 3,
                tags: [{value: '四钻酒店', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '老君山', type: 'success'}, {value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('锦绣洛阳3天2晚15人.jpg')},
            {label: '锦绣洛阳3天2晚2-8人',day: 3,
                tags: [{value: '四钻酒店', type: 'primary'}, {value: '8人团', type: 'danger'}, {value: '老君山', type: 'success'}, {value: '龙门石窟', type: 'success'}, {value: '白马寺', type: 'success'}, {value: '洛阳博物馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('锦绣洛阳3天2晚2-8人.jpg')},
            {label: '龙潭峡2-8人',day: 1,
                tags: [{value: '一日游', type: 'primary'}, {value: '8人团', type: 'danger'}, {value: '龙潭大峡谷', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('龙潭峡2-8人.jpg')},
            {label: '龙门少林15人',day: 1,
                tags: [{value: '一日游', type: 'primary'}, {value: '15人团', type: 'danger'}, {value: '龙门石窟', type: 'success'},{value: '龙门石窟', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('龙潭峡2-8人.jpg')},
        ]
    },
    {
        label: '国内游',
        children: [
            {label: '青岛日照四日游(普座)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '青岛日照四日游(普座)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '青岛日照四日游(半卧)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '华东五省四日游(普座)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '华东五省四日游(半卧)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '威海四日游(普座)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '威海四日游(半卧)',disabled: true,day: 4,
                image: CommonFunction.generateGithubImageUrl('lvtuxiangdaozhe.jpg')},
            {label: '时光隧道，千年窑湾',day: 3,
                tags: [{value: '三日游', type: 'primary'}, {value: '限时特价', type: 'danger'}, {value: '户部山', type: 'success'},{value: '回龙窝', type: 'success'},{value: '窑湾古镇', type: 'success'},{value: '马陵山', type: 'success'},{value: '淮海战役纪念馆', type: 'success'}],
                image: CommonFunction.generateGithubImageUrl('时光隧道，千年窑湾.jpg')},
        ]
    },
    {
        label: '出境游',
        children: []
    },


]

export const COUNTRY_CODE = [
    {
        label: '亚洲国际电话区号',
        children: [
            {subLabel: '中国', label: '+86'},
            {subLabel: '中国香港', label: '+852'},
            {subLabel: '中国澳门', label: '+853'},
            {subLabel: '中国台湾', label: '+886'},
            {subLabel: '英属印度洋领地', label: '+246'},
            {subLabel: '亚美尼亚', label: '+374'},
            {subLabel: '马来西亚', label: '+60'},
            {subLabel: '圣诞岛', label: '+61'},
            {subLabel: '科科斯（基林）群岛', label: '+61'},
            {subLabel: '印度尼西亚', label: '+62'},
            {subLabel: '菲律宾', label: '+63'},
            {subLabel: '新加坡', label: '+65'},
            {subLabel: '泰国', label: '+66'},
            {subLabel: '东帝汶', label: '+670'},
            {subLabel: '文莱', label: '+673'},
            {subLabel: '日本', label: '+81'},
            {subLabel: '韩国', label: '+82'},
            {subLabel: '越南', label: '+84'},
            {subLabel: '朝鲜', label: '+850'},
            {subLabel: '柬埔寨', label: '+855'},
            {subLabel: '老挝', label: '+856'},
            {subLabel: '孟加拉', label: '+880'},
            {subLabel: '土耳其', label: '+90'},
            {subLabel: '印度', label: '+91'},
            {subLabel: '巴基斯坦', label: '+92'},
            {subLabel: '阿富汗', label: '+93'},
            {subLabel: '斯里兰卡', label: '+94'},
            {subLabel: '缅甸', label: '+95'},
            {subLabel: '马尔代夫', label: '+960'},
            {subLabel: '黎巴嫩', label: '+961'},
            {subLabel: '约旦', label: '+962'},
            {subLabel: '叙利亚', label: '+963'},
            {subLabel: '伊拉克', label: '+964'},
            {subLabel: '科威特', label: '+965'},
            {subLabel: '也门', label: '+967'},
            {subLabel: '阿曼', label: '+968'},
            {subLabel: '巴勒斯坦', label: '+970'},
            {subLabel: '阿联酋', label: '+971'},
            {subLabel: '以色列', label: '+972'},
            {subLabel: '巴林', label: '+973'},
            {subLabel: '卡塔尔', label: '+974'},
            {subLabel: '不丹', label: '+975'},
            {subLabel: '蒙古', label: '+976'},
            {subLabel: '尼泊尔', label: '+977'},
            {subLabel: '伊朗', label: '+98'},
            {subLabel: '塔吉克斯坦', label: '+992'},
            {subLabel: '土库曼斯坦', label: '+993'},
            {subLabel: '阿塞拜疆', label: '+994'},
            {subLabel: '格鲁吉亚', label: '+995'},
            {subLabel: '吉尔吉斯斯坦', label: '+996'},
            {subLabel: '哈萨克斯坦', label: '+997'},
            {subLabel: '乌兹别克斯坦', label: '+998'}
        ]
    },
    {
        label: '欧洲国际电话区号', children: [
            {subLabel: '法罗群岛', label: '+298'},
            {subLabel: '希腊', label: '+30'},
            {subLabel: '荷兰', label: '+31'},
            {subLabel: '比利时', label: '+32'},
            {subLabel: '法国', label: '+33'},
            {subLabel: '西班牙', label: '+34'},
            {subLabel: '直布罗陀', label: '+350'},
            {subLabel: '葡萄牙', label: '+351'},
            {subLabel: '卢森堡', label: '+352'},
            {subLabel: '爱尔兰', label: '+353'},
            {subLabel: '冰岛', label: '+354'},
            {subLabel: '阿尔巴尼亚', label: '+355'},
            {subLabel: '马耳他', label: '+356'},
            {subLabel: '塞浦路斯', label: '+357'},
            {subLabel: '芬兰', label: '+358'},
            {subLabel: '奥兰群岛', label: '+358-18'},
            {subLabel: '保加利亚', label: '+359'},
            {subLabel: '匈牙利', label: '+36'},
            {subLabel: '立陶宛', label: '+370'},
            {subLabel: '拉脱维亚', label: '+371'},
            {subLabel: '爱沙尼亚', label: '+372'},
            {subLabel: '摩尔多瓦', label: '+373'},
            {subLabel: '白俄罗斯', label: '+375'},
            {subLabel: '安道尔', label: '+376'},
            {subLabel: '摩纳哥', label: '+377'},
            {subLabel: '圣马力诺', label: '+378'},
            {subLabel: '梵蒂冈', label: '+379'},
            {subLabel: '乌克兰', label: '+380'},
            {subLabel: '塞尔维亚', label: '+381'},
            {subLabel: '黑山', label: '+382'},
            {subLabel: '科索沃', label: '+383'},
            {subLabel: '克罗地亚', label: '+385'},
            {subLabel: '斯洛文尼亚', label: '+386'},
            {subLabel: '波黑', label: '+387'},
            {subLabel: '北马其顿', label: '+389'},
            {subLabel: '意大利', label: '+39'},
            {subLabel: '罗马尼亚', label: '+40'},
            {subLabel: '瑞士', label: '+41'},
            {subLabel: '捷克', label: '+420'},
            {subLabel: '斯洛伐克', label: '+421'},
            {subLabel: '列支敦士登', label: '+423'},
            {subLabel: '奥地利', label: '+43'},
            {subLabel: '英国', label: '+44'},
            {subLabel: '根西岛', label: '+44-1481'},
            {subLabel: '泽西岛', label: '+44-1534'},
            {subLabel: '马恩岛', label: '+44-1624'},
            {subLabel: '丹麦', label: '+45'},
            {subLabel: '瑞典', label: '+46'},
            {subLabel: '挪威', label: '+47'},
            {subLabel: '斯瓦尔巴和扬马延群岛', label: '+47'},
            {subLabel: '波兰', label: '+48'},
            {subLabel: '德国', label: '+49'},
            {subLabel: '俄罗斯', label: '+7'}
        ]
    },
    {
        label: '大洋洲国际电话区号', children: [
            {subLabel: '北马里亚纳群岛', label: '+1-670'},
            {subLabel: '关岛', label: '+1-671'},
            {subLabel: '美属萨摩亚', label: '+1-684'},
            {subLabel: '澳大利亚', label: '+61'},
            {subLabel: '新西兰', label: '+64'},
            {subLabel: '赫德·唐纳岛及麦唐纳岛', label: '+672'},
            {subLabel: '诺福克岛', label: '+672'},
            {subLabel: '巴布亚新几内亚', label: '+675'},
            {subLabel: '汤加', label: '+676'},
            {subLabel: '所罗门群岛', label: '+677'},
            {subLabel: '瓦努阿图', label: '+678'},
            {subLabel: '斐济', label: '+679'},
            {subLabel: '帕劳', label: '+680'},
            {subLabel: '瓦利斯群岛和富图纳群岛', label: '+681'},
            {subLabel: '库克群岛', label: '+682'},
            {subLabel: '纽埃', label: '+683'},
            {subLabel: '萨摩亚', label: '+685'},
            {subLabel: '基里巴斯', label: '+686'},
            {subLabel: '新喀里多尼亚', label: '+687'},
            {subLabel: '图瓦卢', label: '+688'},
            {subLabel: '法属波利尼西亚', label: '+689'},
            {subLabel: '托克劳群岛', label: '+690'},
            {subLabel: '密克罗尼西亚联邦', label: '+691'},
            {subLabel: '马绍尔群岛', label: '+692'},
            {subLabel: '皮特凯恩群岛', label: '+870'}
        ]
    },
    {
        label: '北美洲国际电话区号', children: [
            {subLabel: '加拿大', label: '+1'},
            {subLabel: '美国', label: '+1'},
            {subLabel: '美本土外小岛屿', label: '+1'},
            {subLabel: '巴巴多斯', label: '+1-246'},
            {subLabel: '安圭拉', label: '+1-264'},
            {subLabel: '安提瓜和巴布达', label: '+1-268'},
            {subLabel: '英属维尔京群岛', label: '+1-284'},
            {subLabel: '维尔京群岛（美国）', label: '+1-340'},
            {subLabel: '开曼群岛', label: '+1-345'},
            {subLabel: '百慕大群岛', label: '+1-441'},
            {subLabel: '格林纳达', label: '+1-473'},
            {subLabel: '特克斯和凯科斯群岛', label: '+1-649'},
            {subLabel: '蒙特塞拉特', label: '+1-664'},
            {subLabel: '圣卢西亚', label: '+1-758'},
            {subLabel: '多米尼克', label: '+1-767'},
            {subLabel: '圣文森特和格林纳丁斯', label: '+1-784'},
            {subLabel: '波多黎各', label: '+1-787'},
            {subLabel: '多米尼加', label: '+1-809'},
            {subLabel: '特立尼达和多巴哥', label: '+1-868'},
            {subLabel: '圣基茨和尼维斯', label: '+1-869'},
            {subLabel: '牙买加', label: '+1-876'},
            {subLabel: '阿鲁巴', label: '+297'},
            {subLabel: '格陵兰岛', label: '+299'},
            {subLabel: '伯利兹', label: '+501'},
            {subLabel: '萨尔瓦多', label: '+503'},
            {subLabel: '尼加拉瓜', label: '+505'},
            {subLabel: '哥斯达黎加', label: '+506'},
            {subLabel: '巴拿马', label: '+507'},
            {subLabel: '圣皮埃尔和密克隆群岛', label: '+508'},
            {subLabel: '海地', label: '+509'},
            {subLabel: '秘鲁', label: '+51'},
            {subLabel: '墨西哥', label: '+52'},
            {subLabel: '古巴', label: '+53'},
            {subLabel: '瓜德罗普岛', label: '+590'},
            {subLabel: '圣巴泰勒米岛', label: '+590'},
            {subLabel: '巴拉圭', label: '+595'},
            {subLabel: '马提尼克', label: '+596'},
            {subLabel: '博内尔岛、圣尤斯特歇斯和萨巴岛', label: '+599'},
            {subLabel: '库拉索', label: '+599'}]
    },
    {
        label: '南美洲国际电话区号', children: [
            {subLabel: '圣马丁岛（荷兰部分）', label: '+1-721'},
            {subLabel: '马尔维纳斯群岛', label: '+500'},
            {subLabel: '南乔治亚岛和南桑威奇群岛', label: '+500'},
            {subLabel: '危地马拉', label: '+502'},
            {subLabel: '洪都拉斯', label: '+504'},
            {subLabel: '阿根廷', label: '+54'},
            {subLabel: '巴西', label: '+55'},
            {subLabel: '智利', label: '+56'},
            {subLabel: '哥伦比亚', label: '+57'},
            {subLabel: '委内瑞拉', label: '+58'},
            {subLabel: '圣马丁（法属部分）', label: '+590'},
            {subLabel: '玻利维亚', label: '+591'},
            {subLabel: '圭亚那', label: '+592'},
            {subLabel: '厄瓜多尔', label: '+593'},
            {subLabel: '法属圭亚那', label: '+594'},
            {subLabel: '苏里南', label: '+597'},
            {subLabel: '乌拉圭', label: '+598'},
            {subLabel: '瑙鲁', label: '+674'}
        ]
    },
    {
        label: '非洲国际电话区号', children: [
            {subLabel: '埃及', label: '+20'},
            {subLabel: '南苏丹', label: '+211'},
            {subLabel: '摩洛哥', label: '+212'},
            {subLabel: '西撒哈拉', label: '+212'},
            {subLabel: '阿尔及利亚', label: '+213'},
            {subLabel: '突尼斯', label: '+216'},
            {subLabel: '利比亚', label: '+218'},
            {subLabel: '冈比亚', label: '+220'},
            {subLabel: '塞内加尔', label: '+221'},
            {subLabel: '毛里塔尼亚', label: '+222'},
            {subLabel: '马里', label: '+223'},
            {subLabel: '几内亚', label: '+224'},
            {subLabel: '科特迪瓦', label: '+225'},
            {subLabel: '布基纳法索', label: '+226'},
            {subLabel: '尼日尔', label: '+227'},
            {subLabel: '多哥', label: '+228'},
            {subLabel: '贝宁', label: '+229'},
            {subLabel: '毛里求斯', label: '+230'},
            {subLabel: '利比里亚', label: '+231'},
            {subLabel: '塞拉利昂', label: '+232'},
            {subLabel: '加纳', label: '+233'},
            {subLabel: '尼日利亚', label: '+234'},
            {subLabel: '乍得', label: '+235'},
            {subLabel: '中非', label: '+236'},
            {subLabel: '喀麦隆', label: '+237'},
            {subLabel: '佛得角', label: '+238'},
            {subLabel: '圣多美和普林西比', label: '+239'},
            {subLabel: '赤道几内亚', label: '+240'},
            {subLabel: '加蓬', label: '+241'},
            {subLabel: '刚果共和国', label: '+242'},
            {subLabel: '刚果民主共和国', label: '+243'},
            {subLabel: '安哥拉', label: '+244'},
            {subLabel: '几内亚比绍', label: '+245'},
            {subLabel: '塞舌尔', label: '+248'},
            {subLabel: '苏丹', label: '+249'},
            {subLabel: '卢旺达', label: '+250'},
            {subLabel: '埃塞俄比亚', label: '+251'},
            {subLabel: '索马里', label: '+252'},
            {subLabel: '吉布提', label: '+253'},
            {subLabel: '肯尼亚', label: '+254'},
            {subLabel: '坦桑尼亚', label: '+255'},
            {subLabel: '乌干达', label: '+256'},
            {subLabel: '布隆迪', label: '+257'},
            {subLabel: '莫桑比克', label: '+258'},
            {subLabel: '赞比亚', label: '+260'},
            {subLabel: '马达加斯加', label: '+261'},
            {subLabel: '法属南部领地', label: '+262'},
            {subLabel: '马约特', label: '+262'},
            {subLabel: '留尼汪岛', label: '+262'},
            {subLabel: '津巴布韦', label: '+263'},
            {subLabel: '纳米比亚', label: '+264'},
            {subLabel: '马拉维', label: '+265'},
            {subLabel: '莱索托', label: '+266'},
            {subLabel: '博茨瓦纳', label: '+267'},
            {subLabel: '斯威士兰', label: '+268'},
            {subLabel: '科摩罗', label: '+269'},
            {subLabel: '南非', label: '+27'},
            {subLabel: '圣赫勒拿岛', label: '+290'},
            {subLabel: '厄立特里亚', label: '+291'}]
    },
    {
        label: '南极洲国际电话区号', children: [{subLabel: '布韦岛', label: '+47'}
        ]
    }
];
export const COUNTRY_CODE_LIST = ["+246","+374","+60","+61","+61","+62","+63","+65","+66","+670","+673","+81","+82","+84","+850","+855","+856","+86","+852","+853","+886","+880","+90","+91","+92","+93","+94","+95","+960","+961","+962","+963","+964","+965","+967","+968","+970","+971","+972","+973","+974","+975","+976","+977","+98","+992","+993","+994","+995","+996","+997","+998","+298","+30","+31","+32","+33","+34","+350","+351","+352","+353","+354","+355","+356","+357","+358","+358-18","+359","+36","+370","+371","+372","+373","+375","+376","+377","+378","+379","+380","+381","+382","+383","+385","+386","+387","+389","+39","+40","+41","+420","+421","+423","+43","+44","+44-1481","+44-1534","+44-1624","+45","+46","+47","+47","+48","+49","+7","+1-670","+1-671","+1-684","+61","+64","+672","+672","+675","+676","+677","+678","+679","+680","+681","+682","+683","+685","+686","+687","+688","+689","+690","+691","+692","+870","+1","+1","+1","+1-246","+1-264","+1-268","+1-284","+1-340","+1-345","+1-441","+1-473","+1-649","+1-664","+1-758","+1-767","+1-784","+1-787","+1-809","+1-868","+1-869","+1-876","+297","+299","+501","+503","+505","+506","+507","+508","+509","+51","+52","+53","+590","+590","+595","+596","+599","+599","+1-721","+500","+500","+502","+504","+54","+55","+56","+57","+58","+590","+591","+592","+593","+594","+597","+598","+674","+20","+211","+212","+212","+213","+216","+218","+220","+221","+222","+223","+224","+225","+226","+227","+228","+229","+230","+231","+232","+233","+234","+235","+236","+237","+238","+239","+240","+241","+242","+243","+244","+245","+248","+249","+250","+251","+252","+253","+254","+255","+256","+257","+258","+260","+261","+262","+262","+262","+263","+264","+265","+266","+267","+268","+269","+27","+290","+291","+47"];
export const CLASSES_LIST = Object.freeze([
    {
        text: '早班', desc: '🧡早班：\n' +
            'ℹ️出发时间：06:50火车站附近、07:10应天门附近、07:30国宝大厦东门、07:40高铁站附近\n' +
            'ℹ️返程时间：16:00～16:30左右，约19:00到市区\n' +
            'ℹ️车型：35~63座大巴车(车型随机)',
        include: '老君山'
    },
    {
        text: '中班', desc: '🩷中班：\n' +
            'ℹ️出发时间：08:50火车站附近、09:10丽景门附近、09:40高铁站附近\n' +
            'ℹ️返程时间：19:00～20:00左右，约22:30左右到市区\n' +
            'ℹ️车型：35~63座大巴车(车型随机)',
        include: '老君山'
    },
    {
        text: '晚班', desc: '🩷晚班：\n' +
            'ℹ️出发时间：09:50火车站附近、10:10丽景门附近、10:40高铁站附近\n' +
            'ℹ️返程时间：20:00～20:30左右，约23:00左右到市区\n' +
            'ℹ️车型：35~63座大巴车(车型随机)',
        include: '老君山'
    },
    {
        text: '夜爬', desc: '🩷夜爬：\n' +
            'ℹ️出发时间：当日18:00火车站附近、19:10丽景门附近、19:30国宝大厦东门附近、19:40高铁站附近\n' +
            'ℹ️返程时间：次日早07:001左右，约次日11:00左右到市区\n' +
            'ℹ️车型：35~63座大巴车(车型随机)', disabled: true,
        include: '老君山'
    },
    {
        text: '小团（15-17人）', desc: '🩷小车团：\n' +
            'ℹ️出发时间：早09:30~10:00左右开始按规划顺序接站，具体时间以导游通知为准，市区范围内免费上门接送\n' +
            'ℹ️返程时间：冬季20:30，夏季21:00，具体时间以下线咨询答复为准\n' +
            'ℹ️车型：19~22座中巴车(车型随机)',
        include: '老君山'
    }]);
